<script>
export default {
    name: "p-textarea",
    props: ['value','name','label', 'minlength', 'maxlength', 'required', 'validate', 'rows', 'error'],
    data() {
        return {
            filterIsActive: false
        }
    },
    methods: {
        updateData(value) {
            this.$emit('input', value)
        }
    },
    computed: {
        inputListeners: function () {
            var vm = this
            return Object.assign({},
            this.$listeners,{
                input: function (event) {
                    vm.$emit('input', event.target.value)
                }
            })
        }
    }, 
    created: function() {}
}
</script>
<template>
    <div class="p-input field" :class="{active: filterIsActive}">
        <label :for="name" class="label">
            <span>{{label}}:</span>
        </label>
        <div class="inner i-ta" :class="{ error: error }">
            <textarea :id="name" :value="value" :rows="rows" :validate="validate" :required="required" :minlength="minlength" :maxlength="maxlength" :name="name" :data-name="label" ref="textPicker" v-on="inputListeners" class="input" @focus="filterIsActive = true" @blur="filterIsActive = false" />
        </div>
        <span class="error-status">{{error}}</span>
    </div>
</template>
<style lang="scss">
    .i-ta {
        height: auto !important;
    }
</style>



// WEBPACK FOOTER //
// src/js/components/p-textarea.vue